import React, { useState } from "react";
import api from "../lib/api";
import { X, Warning } from "@phosphor-icons/react";

const REASONS = [
  "Hate speech",
  "Harassment / bullying",
  "Nudity or sexual content",
  "Violence or harm",
  "Scam / impersonation",
  "Copyright violation",
  "Spam",
  "Other",
];

export default function ReportModal({ target, onClose }) {
  const [reason, setReason] = useState(REASONS[0]);
  const [detail, setDetail] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setMsg("");
    try {
      await api.post("/reports", {
        target_type: target.type,
        target_id: target.id,
        reason,
        detail,
      });
      setMsg("Report submitted. Our team will review it within 48 hours.");
      setTimeout(onClose, 1500);
    } catch (e) {
      setMsg(e.response?.data?.detail || "Failed to submit.");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[120] flex items-end" data-testid="report-modal">
      <div className="absolute inset-0 bg-ink/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full crystal-glass rounded-t-3xl border-t border-x border-white/10 animate-fade-up p-5 pb-10">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Warning size={22} weight="fill" className="text-red-400" />
            <h3 className="text-cream text-2xl font-black tracking-tight">Report</h3>
          </div>
          <button onClick={onClose} data-testid="report-close" className="p-2 rounded-full hover:bg-white/5">
            <X size={22} className="text-cream" />
          </button>
        </div>
        <p className="text-cream/60 text-sm mb-4">Tell us what's wrong with this {target.type}. We review every report.</p>

        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5" data-testid="report-reasons">
            {REASONS.map((r) => (
              <label key={r} className={`flex items-center gap-3 p-3 rounded-2xl cursor-pointer transition-colors ${reason === r ? "bg-papaya/20 border border-papaya/40" : "bg-white/5 border border-white/5 hover:border-white/15"}`}>
                <input type="radio" name="reason" value={r} checked={reason === r} onChange={() => setReason(r)} className="accent-papaya" />
                <span className="text-cream text-sm">{r}</span>
              </label>
            ))}
          </div>
          <textarea
            data-testid="report-detail"
            value={detail}
            onChange={(e) => setDetail(e.target.value)}
            rows={3}
            maxLength={1000}
            placeholder="Add details (optional)…"
            className="w-full bg-white/5 border border-white/10 rounded-2xl px-4 py-3 text-cream placeholder:text-cream/30 focus:outline-none focus:border-papaya resize-none"
          />
          {msg && <p data-testid="report-msg" className="text-sm text-cream/80">{msg}</p>}
          <button
            data-testid="report-submit"
            type="submit"
            disabled={busy}
            className="w-full py-3 rounded-full bg-red-500/90 hover:bg-red-500 text-cream font-black tracking-[0.2em] uppercase text-sm transition-colors disabled:opacity-50"
          >
            {busy ? "Submitting…" : "Submit report"}
          </button>
        </form>
      </div>
    </div>
  );
}
